module.exports = __webpack_public_path__ + "img/phone_hand_desktop.fc305d13.png";